import React from 'react';
import { useT } from '../../i18n/useT';
import './LegalPage.css';

export default function LegalPage({ title, lastUpdated, children }) {
  const t = useT();
  const lp = t.legalPages;

  return (
    <div className="legal-page">
      {/* Hero */}
      <section className="legal-page__hero">
        <div className="container-narrow">
          <div className="badge badge-gray">{lp.badge}</div>
          <h1 className="legal-page__title">{title}</h1>
          {lastUpdated && (
            <p className="legal-page__meta">
              {lp.lastUpdated} <time>{lastUpdated}</time>
            </p>
          )}
          <div className="legal-page__disclaimer">
            {lp.disclaimer}
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="section-sm">
        <div className="container-narrow">
          <div className="legal-page__content">
            {children}
          </div>
        </div>
      </section>
    </div>
  );
}

export function LegalSection({ id, title, children }) {
  return (
    <section className="legal-section" id={id}>
      <h2 className="legal-section__title">{title}</h2>
      <div className="legal-section__content">{children}</div>
    </section>
  );
}

export function LegalPlaceholder({ label }) {
  return (
    <span className="legal-placeholder" title="This is a placeholder that must be filled in before launch">
      [PLACEHOLDER: {label}]
    </span>
  );
}

export function LegalNote({ children }) {
  return <div className="legal-note">{children}</div>;
}
